import { takeEvery } from 'redux-saga/effects';

// internal
import * as ActionType from '@app/store/typings/actions/account.d';
import * as login from '@app/store/sagas/account/login';
import * as register from '@app/store/sagas/account/register';

export function* accountSaga() {
  yield takeEvery(ActionType.KEY_ACCOUNT_LOGIN_FETCH, login.handle);
  yield takeEvery(ActionType.KEY_ACCOUNT_EMAIL_AVAILABILITY, register.emailHandle);
  yield takeEvery(ActionType.KEY_ACCOUNT_PHONE_AVAILABILITY, register.phoneHandle);
  yield takeEvery(ActionType.KEY_ACCOUNT_GEN_OTP, register.generateOTP);
  yield takeEvery(ActionType.KEY_ACCOUNT_VALIDATE_EMAIL_OTP, register.validateEmailOTP);
  yield takeEvery(ActionType.KEY_ACCOUNT_VALIDATE_PHONE_OTP, register.validatePhoneOTP);
  yield takeEvery(ActionType.KEY_VALIDATE_INVITE_EMAIL, register.validateInviteEmail);
  yield takeEvery(ActionType.KEY_GEN_INVITE_OTP, register.generateInviteOTP);
  yield takeEvery(ActionType.KEY_VALIDATE_INVITE_PHONE, register.validateInvitePhone);
  yield takeEvery(
    ActionType.KEY_ACCOUNT_VALIDATE_PHONE_OTP_UPDATE_PROFILE,
    register.updateUserPhone,
  );
  yield takeEvery(
    ActionType.KEY_ACCOUNT_VALIDATE_EMAIL_OTP_UPDATE_PROFILE,
    register.updateUserEmail,
  );
}
